import { render } from "./ScanPage.vue?vue&type=template&id=24836bb0"
import script from "./ScanPage.vue?vue&type=script&lang=js"
export * from "./ScanPage.vue?vue&type=script&lang=js"

import "./ScanPage.vue?vue&type=style&index=0&id=24836bb0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__